import {AfterViewInit, Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {TdoDropdownModel} from '../../../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TdoOrganizerFilterDataModel} from './models/tdo-organizer-filter-data.model';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {TdoOrganizerFilterResultModel} from './models/tdo-organizer-filter-result.model';
import {TdoBasicDropdownComponent} from '../../../../tdo-controls/common/tdo-basic-dropdown/tdo-basic-dropdown.component';
import {DoctorScheduleModel} from '../../../../models/doctors/doctor-schedule.model';
import {OrganizerTimeModel} from '../../../controls/tdo-organizer/models/organizer-time.model';
import {OrganizerFilterDateRangeHandler} from '../../../controls/tdo-organizer/models/organizer-filter-date-range.handler';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';

@Component({
  standalone: false,
  selector: 'app-tdo-organizer-filter',
  templateUrl: './tdo-organizer-filter.component.html',
  styleUrls: ['./tdo-organizer-filter.component.scss']
})
export class TdoOrganizerFilterComponent implements OnInit, AfterViewInit {
  @ViewChild('doctorDrop') doctorDrop: TdoBasicDropdownComponent;
  @ViewChild('referringDoctorDrop') referringDoctorDrop: TdoBasicDropdownComponent;
  @ViewChild('predefinedDateDrop') predefinedDateDrop: TdoBasicDropdownComponent;

  doctorDropdownData: TdoDropdownModel[];
  referringDoctorDropdownData: TdoDropdownModel[];
  documentTagOptions: EnumValidValueItemModel[];

  selectedCategories: EnumValidValueItemModel[] = [];

  filterModel: TdoOrganizerFilterResultModel;

  isAllCategoriesChecked = false;
  isAllCategoriesMustBePresent = false;
  staticData: TdoOrganizerFilterDataModel;

  datePickerStart = new Date(2016, 0, 1);
  datePickerEnd = new Date();

  isWasNotApplied = false;

  constructor(private dialogRef: MatDialogRef<TdoOrganizerFilterComponent>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.staticData = data as TdoOrganizerFilterDataModel;

    if (this.staticData.filterModel) {
      this.filterModel = this.staticData.filterModel;
      for (const mod of this.filterModel.categoriesEnums) {
        const match = this.staticData.documentTagOptions.find(p => p.ValidValueItemId === mod);
        if (match) {
          this.selectedCategories.push(match);
        }
      }
    } else {
      this.filterModel = new TdoOrganizerFilterResultModel();
    }

    this.isWasNotApplied = false;
    this.filterModel.isWasNotApplied = false;

    this.doctorDropdownData = this.staticData.doctorsDropdownData;
    this.referringDoctorDropdownData = this.staticData.referringDoctorsDropdownData;
    this.documentTagOptions = this.staticData.documentTagOptions;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    const drModel = this.staticData.doctorsDropdownData.find(p => p.value === this.filterModel.doctor);
    if (drModel) {
      this.doctorDrop.value = drModel;
      this.doctorDrop.placeholder = drModel.value.FirstName + ' ' + drModel.value.LastName;
    }

    const referringDrModel = this.staticData.referringDoctorsDropdownData.find(p => p.value === this.filterModel.referringDoctor);
    if (referringDrModel) {
      this.referringDoctorDrop.value = referringDrModel;
      this.referringDoctorDrop.placeholder = referringDrModel.value.FirstName + ' ' + referringDrModel.value.LastName;
    }

    const predefinedDateModel = this.staticData.dateRangeDropDownData.find(p => p.value === this.filterModel.range);
    if (predefinedDateModel) {
      this.predefinedDateDrop.value = predefinedDateModel;
      this.predefinedDateDrop.placeholder = (predefinedDateModel.value as EnumValidValueItemModel).ItemDisplayValue;
    }
  }

  onCategoryChange(event: MatCheckboxChange, item: EnumValidValueItemModel) {
    if (!event.checked) {
      this.isAllCategoriesChecked = false;
    }

    if (!this.selectedCategories.includes(item)) {
      this.selectedCategories.push(item);
    } else {
      const idx = this.selectedCategories.findIndex(p => p === item);
      if (idx > -1) {
        this.selectedCategories.splice(idx, 1);
      }
    }
  }

  onAllCategoriesChange(event: MatCheckboxChange) {
    this.isAllCategoriesChecked = event.checked;
    if (!this.isAllCategoriesChecked) {
      this.selectedCategories = [];
    } else {
      this.selectedCategories = this.documentTagOptions.concat();
    }
  }

  isOptionChecked(option: EnumValidValueItemModel) {
    return this.selectedCategories.includes(option);
  }

  onDoctorSelected(event: TdoDropdownModel) {
    this.filterModel.doctor = event.value as DoctorScheduleModel;
  }

  onReferringDoctorSelected(event: TdoDropdownModel) {
    this.filterModel.referringDoctor = event.value as DoctorScheduleModel;
  }

  // Bottom buttons
  onApply() {
    this.filterModel.categoriesEnums = this.selectedCategories.map(p => p.ValidValueItemId);
    this.dialogRef.close(this.filterModel);
  }

  onClear() {
    this.filterModel = new TdoOrganizerFilterResultModel();
    this.selectedCategories = [];
    this.isAllCategoriesChecked = false;
    this.isAllCategoriesMustBePresent = false;

    this.doctorDrop.placeholder = 'Provider';
    this.referringDoctorDrop.placeholder = 'Referring';
    this.predefinedDateDrop.placeholder = 'Specific Range';
  }

  onCancel() {
    this.filterModel.isWasNotApplied = true;
    this.dialogRef.close(this.filterModel);
  }

  isFilterActive() {
    const isNoCriteria = !this.filterModel.isCompletedCases && !this.filterModel.isGentleWaveProcedure && !this.filterModel.isInTreatment && !this.filterModel.isNoDefinitiveEndoPerformed && !this.filterModel.isSuperRecall;
    if (this.filterModel.doctor || this.filterModel.referringDoctor || this.selectedCategories.length > 0 || this.filterModel.range || !isNoCriteria) {
      return true;
    }
    return false;
  }

  onPredefinedDateSelected(event: TdoDropdownModel) {
    this.filterModel.range = event.value as EnumValidValueItemModel;
    const om = OrganizerFilterDateRangeHandler.getTimeFromRange(this.filterModel.range);
    this.filterModel.startDate = new Date(om.start);
    this.filterModel.endDate = new Date(om.end);
  }

  onStartDateChange(event: MatDatepickerInputEvent<Date, Date | null>) {
    const ddModel = this.staticData.dateRangeDropDownData.find(p => (p.value as EnumValidValueItemModel).ValidValueItemId === '00000163-1000-0000-0000-000000000014');
    if (ddModel) {
      this.filterModel.range = ddModel.value as EnumValidValueItemModel;
      this.predefinedDateDrop.value = ddModel;
      this.predefinedDateDrop.placeholder = (ddModel.value as EnumValidValueItemModel).ItemDisplayValue;
    }
    this.filterModel.startDateMs = event.value.getTime();
  }

  onEndDateChange(event: MatDatepickerInputEvent<Date, Date | null>) {
    const ddModel = this.staticData.dateRangeDropDownData.find(p => (p.value as EnumValidValueItemModel).ValidValueItemId === '00000163-1000-0000-0000-000000000014');
    if (ddModel) {
      this.filterModel.range = ddModel.value as EnumValidValueItemModel;
      this.predefinedDateDrop.value = ddModel;
      this.predefinedDateDrop.placeholder = (ddModel.value as EnumValidValueItemModel).ItemDisplayValue;
    }
    this.filterModel.endDateMs = event.value.getTime();
  }

  getStartDate() {
    return new Date(this.filterModel.startDateMs);
  }

  getEndDate() {
    return new Date(this.filterModel.endDateMs);
  }
}
